import { render, staticRenderFns } from "./DContainerLayout.vue?vue&type=template&id=4574def9&scoped=true"
import script from "./DContainerLayout.vue?vue&type=script&setup=true&lang=ts"
export * from "./DContainerLayout.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./DContainerLayout.vue?vue&type=style&index=0&id=4574def9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4574def9",
  null
  
)

export default component.exports